<template>
  <div class="guest-book-view">
    <h2>留言板</h2>

    <!-- 发表新留言 -->
    <form @submit.prevent="submitMessage" class="message-form">
      <textarea v-model="newMsg.content" placeholder="请输入留言内容" required></textarea>
      <input v-model="newMsg.contact" type="text" placeholder="您的联系方式（如邮箱、电话）" required />
      <button type="submit">提交留言</button>
    </form>

    <!-- 留言列表（含 +1） -->
    <div class="message-list">
      <div v-for="msg in messages" :key="msg._id" class="message-item top-level">
        <div class="message-header">
          <span class="time">{{ msg.time }}</span>
        </div>
        <div class="message-body">{{ msg.content }}</div>

        <!-- +1 区域 -->
        <div class="like-area">
          <button class="like-btn" @click="plusOne(msg._id)">
            +1
          </button>
          <span class="like-count">{{ msg.likes || 0 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import http from '@/api/http'

/* ---------------- 数据 ---------------- */
const loadMessages = () => {
  http.get('/api/guestbook', {})
    .then(res => {
      const data = res.data
      if (data.result !== 'ok') return ElMessage.error(data.msg)
      if (data.msg == null || data.msg == '') {
        return
      }
      messages.value = JSON.parse(data.msg)
    })
    .catch(() => ElMessage.error('网络异常'))
}
let messages = ref([])

const newMsg = reactive({ content: '', contact: '' })

/* ---------------- 方法 ---------------- */
function submitMessage() {
  if (!newMsg.content.trim() || !newMsg.contact.trim()) return
  let temp = {
    id: Date.now(),
    content: newMsg.content.trim(),
    contact: newMsg.contact.trim(),
    time: new Date().toLocaleString(),
    likes: 0
  }
  http.post('/api/guestbook', temp)
    .then(res => {
      let data = res.data
      if (data.result !== 'ok') return ElMessage.error(data.msg)
      messages.value.unshift(temp)
      newMsg.content = ''
      newMsg.contact = ''
    })
    .catch(() => ElMessage.error('网络异常'))
}

function plusOne(_id) {
  const target = messages.value.find(m => m._id === _id)
  if (!target) {
    return
  }
  target.likes = (target.likes || 0) + 1
  http.post('/api/guestbook', target)
    .then(res => {
      let data = res.data
      if (data.result !== 'ok') return ElMessage.error(data.msg)      
    })
    .catch(() => ElMessage.error('网络异常'))
}

onMounted(() => {
  loadMessages();
});

</script>

<style scoped>
.guest-book-view {
  max-width: 640px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.message-form {
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
}

.message-form textarea,
.message-form input {
  padding: 8px;
  font-size: 1em;
  margin-bottom: 10px;
}

.message-form button {
  align-self: flex-start;
  padding: 8px 16px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.message-form button:hover {
  background: #0056b3;
}

.message-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.message-item {
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 12px;
}

.message-header {
  display: flex;
  justify-content: space-between;
  font-size: 0.9em;
  color: #555;
  margin-bottom: 8px;
}

.message-body {
  white-space: pre-wrap;
  margin-bottom: 10px;
}

.like-area {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.like-btn {
  padding: 4px 10px;
  background: #28a745;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.like-btn:hover {
  background: #218838;
}

.like-count {
  font-weight: bold;
  color: #333;
}
</style>